import React, { useState, useEffect } from 'react';
import CustomerTableWrapper from 'src/Components/Customer/CustomerTableWrapper';
import PageHeader from 'src/Components/Customer/PageHeader';
import PrimaryBtn from 'src/Components/GlobalComponents/primaryBtn';
import SearchFilterInput from 'src/Components/GlobalComponents/SearchFilterInput';
import { IqueryParams } from 'src/types/GlobalInterfaces';
import { IPaginated } from 'src/types/paginated';
import eyeIcon from "src/assets/images/eye-icon-green.png";
import UnderDevelopment from "src/assets/images/under-development.png";
import { useSelector } from 'react-redux';
import { RootState } from '@store/store';
import SimpleInput from 'src/Components/SimpleInput';
import moment from 'moment';
import PrescribedMedicines from 'src/Components/Customer/Prescription/PrescribedMedicines';
import StartAndEndDateFilter from '../../Components/GlobalComponents/StartAndEndDateFilter';
import httpRequest from 'src/helpers/httpRequest';
import qs from "qs";
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

type tabKeys = "pharmacy" | "diagnostic" | "homecare";
interface IParams extends IqueryParams {
    productType: tabKeys;
};
interface IPrescribedResponse {
    [key: string]: any;

}
interface IPrescribedItem {
    IPrescribedItem?: string;
    [key: string]: any;
}
const PrescriptionsList: React.FC = () => {
    const { allIndicators } = useSelector((store: RootState) => store?.redDots);

    const tabList: { label: string; key: tabKeys; count?: any; }[] = [
        { label: "Prescribed Medicines", key: "pharmacy", count: allIndicators?.prescribedPharmacy },
        { label: "Prescribed Tests", key: "diagnostic", count: allIndicators?.prescribedDiagnostic },
        { label: "Prescribed Services", key: "homecare", count: allIndicators?.prescribedHomeCare },
    ];

    const [isLoader, setIsLoader] = useState<boolean>(false);
    const [prescribedData, setPrescribedData] = useState<IPrescribedItem>([])
    const [paginated, setPaginated] = useState<IPaginated>({
        currentPage: 1,
        totalPages: 1,
    }); // Handles pagination state
    const [queryParams, setQueryParams] = useState<IParams>({
        page: 1,
        limit: 10,
        productType: "pharmacy",
        search: "",
        startDate: "",
        endDate: "",
    }); // Query parameters for API request

    // Handles page change in pagination
    const handlePageChange = (e: number) => {
        setQueryParams(prev => ({
            ...prev,
            page: e
        }));
    };

    const handleTabClick = (tabName: tabKeys) => {
        setPrescribedData([]);
        setQueryParams(prev => ({
            ...prev,
            search: "",
            productType: tabName,
            page: 1,
        }));
    };

    // Handles filter change for search input
    const handleFilterChange = (val: string) => {
        setQueryParams(prev => ({
            ...prev,
            page: 1,
            search: val,
        }));
    };
    const applyFilter = (startDate: string, endDate: string) => {
        setQueryParams(prev => ({
            ...prev,
            page: 1,
            startDate,
            endDate,
        }));
    };
    const resetFilter = () => {
        setQueryParams(prev => ({
            ...prev,
            page: 1,
            startDate: "",
            endDate: "",
        }));
    };
    const FetchPrescibedData = async () => {
        setIsLoader(true);

        const { res, err } = await httpRequest<IPrescribedResponse>({ path: `/appoiment/customer-prescribe-all?${qs.stringify(queryParams)}` });
        if (res) {
            const { documents = [], paginated } = res;
            console.log()
            setPrescribedData(documents);
            setPaginated(paginated);
        } else {
            toast(err, { type: "error" }); // Show error toast if API call fails
        }
        setIsLoader(false);
    }
    useEffect(() => {
        FetchPrescibedData();
    }, [queryParams]);

    return (
        <>
            <PageHeader
                title={`My Prescriptions`}
            />
            <div style={{ minHeight: `calc(${document.getElementById('customer-sidebar-id')?.offsetHeight}px - 1rem - ${document.getElementById('headerH')?.offsetHeight}px)` }} className="parent-box parent-box-height">
                <div className='flex justify-between items-center'>
                    <div className='products-tabs-btn'>
                        {tabList.map((v) => (
                            <button
                                disabled={queryParams?.productType === v.key}
                                key={v.key}
                                className={`relative font-size-15px font-Poppins-Medium rounded-pill ${queryParams?.productType === v.key && 'active'}`}
                                onClick={() => handleTabClick(v.key)}
                            >
                                {v.label}
                                {v.count > 0 && (
                                    <div className="red-dot-show absolute -top-2 -right-1">
                                    </div>
                                )}
                            </button>
                        ))}
                    </div>

                </div>
                <hr className='products-tabs-hr-allOrder' />
                {/* <PrescribedMedicines /> */}
                <div className=" margin-bttom-issue-resolve">
                    <StartAndEndDateFilter
                        reset={resetFilter}
                        apply={applyFilter}
                    />
                </div>
                <CustomerTableWrapper
                    isLoading={isLoader}
                    thead={["Appointment date", "Doctor Name", "Prescription date", `${queryParams?.productType === "pharmacy" ? "Number of medicines" : queryParams?.productType === "diagnostic" ? "Number of test" : "Number of services"}`, "View Details"]}
                    page={paginated?.currentPage || 1}
                    total={paginated?.totalPages || 0}
                    columnWidth={"21% 23% 20% 20% 16%"}
                    onChange={handlePageChange}
                >
                    {prescribedData.map((item: IPrescribedItem, index: number) => (
                        <ul key={index} className={`${!item?.customerNotified ? "font-bold" : ""} font-size-16px tbody-light-table tbody-light-table-customer customer-table-wrapper-body-padding-non customer-table-wrapper-body font-Poppins-Regular grid`} style={{ gridTemplateColumns: "21% 23% 20% 20% 16%" }}>
                            <li className="action-last-colum-non">
                                {item?.appointmentDate ? moment(item?.appointmentDate).format("DD-MM-YYYY") : ""}
                            </li>
                            <li>
                                {item?.firstName + " " + item?.lastName}
                            </li>
                            <li className="">
                                {item?.prescriptionDate ? moment(item?.prescriptionDate).format("DD-MM-YYYY") : ""}
                            </li>
                            <li ><span className='text-center'> {item?.prescriptionCount}</span></li>
                            <li className='action-last-colum'>
                                <Link
                                    to={`/prescribed-details/${queryParams?.productType}/${item?._id}/view`}
                                >
                                    <img src={eyeIcon} alt="" />
                                </Link>
                            </li>
                        </ul>
                    ))}
                </CustomerTableWrapper>
            </div>
        </>
    );
};

export default PrescriptionsList;